import { useState, useEffect } from 'react';
import WebFont from 'webfontloader';

type IFontSource = {
    custom?: {
        families: Array<string>;
        urls: Array<string>;
    };
    google?: {
        families: Array<string>;
    };
};

/**
 *
 * Providing an opportunity to load additional fonts dynamically
 * @param families - Array of font families
 * @param urls - Array of URLs to css files with @font-face (If not provided the hook will use Google Fonts CDN)
 */
const useFont = (families: Array<string>, urls: Array<string> = null): boolean => {
    const fontSelector = families[0].split(' ')[0];
    const fontLink: HTMLElement = document.querySelector(`[href*=${fontSelector}]`);
    const [fontLoaded, setFontLoaded] = useState<boolean>(!!fontLink);

    useEffect(() => {
        if (fontLoaded) {
            return;
        }

        setFontLoaded(false);

        const webFontSource: IFontSource = {};

        if (urls) {
            webFontSource.custom = {
                families,
                urls,
            };
        } else {
            webFontSource.google = {
                families,
            };
        }

        // Loading "Cinzel Decorative" from google fonts
        WebFont.load({
            ...webFontSource,
            classes: false,
            active(): void {
                setFontLoaded(true);
            },
        });
    }, [fontLoaded]);

    return fontLoaded;
};

export default useFont;
